import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ensureKnown, updateArrangement, deleteArrangement } from '../../store/knownArrangementsSlice';
import TextareaAutosize from 'react-textarea-autosize';
import { DataContainer } from '../../components/DataContainer';
import DriverSelect from '../../components/DriverSelect';
import TimeInput from '../../components/TimeInput';
import { toast } from 'react-toastify';
import { timeConverter, dateConverter } from '../../util';
import DurationInput from '../../components/DurationInput';
import { unwrapResult } from '@reduxjs/toolkit';
import DriverSelectStateful from '../../components/DriveSelectStateful';

function EditReoccurring({ id }) {
    const dispatch = useDispatch();
    const driverSelectRef = useRef(null);
    const [ description, setDescription ] = useState("");
    const [ name, setName ] = useState("");
    const [ driver, setDriver ] = useState("");
    const [ depart, setDepart ] = useState("00:00");
    const [ duration, setDuration ] = useState(0);
    const [ days, setDays ] = useState([ false, false, false, true, false, false, false ]);
    const [ startDate, setStartDate ] = useState("");
    const [ endDate, setEndDate ] = useState("");
    const [ loaded, setLoaded ] = useState(false);

    const _data = useSelector((state) => state.knownArrangements);
    const data = _data.arrangements[id];





    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);

    useEffect(() => {
        if(!data) {
            setLoaded(false);
            return;
        }
        console.log("data:", data);
        console.log("db30: ", timeConverter(data["arrangement_start"]));
        
        setDescription(data["arrangement_description"]);
        setName(data["arrangement_name"]);
        setDriver(data["arrangement_driver"]);
        setDays([
            !!data["arrangement_on_monday"],
            !!data["arrangement_on_tuesday"],
            !!data["arrangement_on_wednesday"],
            !!data["arrangement_on_thursday"],
            !!data["arrangement_on_friday"],
            !!data["arrangement_on_saturday"],
            !!data["arrangement_on_sunday"],
        ]);
        setDepart(data["arrangement_depart"]);
        setDuration(data["arrangement_duration"]);
        setStartDate(data["arrangement_start"]);
        setEndDate(data["arrangement_end"]);
        setLoaded(true);
    }, [data]);

    async function onDeleteException() {
        const res = await unwrapResult(await dispatch(deleteArrangement({ id })));

        if(!res) return;

        toast.success("Regulaarvedu kustutatud!");
    }

    async function onSave() {
        const res = await unwrapResult(await dispatch(updateArrangement({
            id,
            name: name,
            description: description,
            driver,
            on_monday: days[0],
            on_tuesday: days[1],
            on_wednesday: days[2],
            on_thursday: days[3],
            on_friday: days[4],
            on_saturday: days[5],
            on_sunday: days[6],
            start: startDate,
            end: endDate,
            depart,
            duration,
        })));

        console.log("res:", res);

        if(!res) return;

        toast.success("Regulaarvedu uuendatud!");
    }

    console.log("db31: start", startDate);



    if(!loaded) return null;

    return (
        <DataContainer actionType={'knownArrangements/updateArrangement'}>
            <div className="column g32">
                <div className="column">
                    <h2>Regulaarveo muutmine</h2>
                    <p>Olemasolevaid erandeid ei kirjutata üle</p>
                </div>
                    
                <div className="line g32 w100">

                    <div className="column g16 grow">

                        <div className="column g4 grow">
                            <b>Kirjeldus</b>
                            <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Täpsusta kui vaja' value={description} onChange={(e) => setDescription(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <div className="column">
                                <b>Algus</b>
                                <p>Esimene päev, millal see vedu toimub. Võib märkida ka selle esimese nädala esmaspäeva.</p>
                            </div>
                            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <div className="column">
                                <b>Lõpp</b>
                                <p>Viimane päev, millal see vedu toimub. Võib märkida ka selle viimase nädala pühapäeva.</p>
                            </div>
                            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                        </div>

                    </div>

                    <div className="column g16 grow">

                        <div className="column g4">
                            <b>Nimi</b>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Juht</b>
                            <DriverSelectStateful value={driver} setValue={setDriver} />
                        </div>

                        <div className="column g4">
                            <b>Väljumine</b>
                            <TimeInput value={depart} onChange={setDepart} useColon={true} />
                        </div>


                        <div className="column g4">
                            <b>Kestvus</b>
                            <TimeInput value={duration} onChange={setDuration} />
                        </div>

                        <div className="column g4">
                            <b>Päevad</b>
                            <div className="line g8">
                                <button style={days[0] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[0] = !days[0]; return nd; })} >
                                    E
                                </button>
                                <button style={days[1] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[1] = !days[1]; return nd; })} >
                                    T
                                </button>
                                <button style={days[2] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[2] = !days[2]; return nd; })} >
                                    K
                                </button>
                                <button style={days[3] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[3] = !days[3]; return nd; })} >
                                    N
                                </button>
                                <button style={days[4] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[4] = !days[4]; return nd; })} >
                                    R
                                </button>
                                <button style={days[5] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[5] = !days[5]; return nd; })} >
                                    L
                                </button>
                                <button style={days[6] ? { backgroundColor: '#d8d8ff', borderColor: '#aad' } : undefined}
                                        onClick={() => setDays(days => { const nd = [...days]; nd[6] = !days[6]; return nd; })} >
                                    P
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row g16" style={{ justifyContent: 'end' }}>
                    <button onClick={onDeleteException} style={{ backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>Kustuta regulaarvedu</button>
                    <button onClick={onSave}>Salvesta</button>
                </div>
            </div>
        </DataContainer>
    );
}

export default EditReoccurring;